import RightImageBox from "./ServiceRightImageBox";
import LeftImageBox from "./ServiceLeftImageBox";
import { useRouter } from "next/router";
import ImageWrapper from "../ImageComponent/ImageWrapper";
import { getCookieItem } from "@/utils/utils";

const PoojaServices = ({ data }) => {
  const imageBoxesData = data.boxesData;
  const router = useRouter();
  const onClickPoojaService = () => {
    const locationName = getCookieItem("location_name")?.toLowerCase();
    const languageName = getCookieItem("language_name")?.toLowerCase();
    router.push(`/${languageName}/${locationName}/pooja`);
  };

  const onClickTempleService = () => {
    router.push("/e-pooja/temple/pujas");
  };
  return (
    <div className="px-6 xs:px-8 sm:px-12 md:px-16 lg:px-20 xl:px-35">
      <div className="flex flex-col w-full md:flex-row justify-center align-middle md:items-end gap-4 md:gap-5 lg:gap-6">
        <div className="flex w-full md:w-[450px] lg:w-[536px] md:flex md:flex-col md:gap-[58px] lg:gap-11">
          <div className="hidden md:flex flex-col text-light-grey-color text-3xl leading-tight w-452 h-28 rounded-2xl">
            <h1 className="tracking-wide leading-tight font-bastoni">
              Your One-Stop <br />
              Destination for
            </h1>
            <span className="text-Default tracking-wide leading-tight font-bastoni">
              Hassle-Free Pooja Booking
            </span>
          </div>
          <div className="w-[100%] h-full md:w-[450px] md:h-[250px] lg:w-536 lg:h-296 rounded-2xl cursor-pointer relative">
            <LeftImageBox
              imageUrl={imageBoxesData[0].imageUrl}
              altText={imageBoxesData[0].altText}
              onClick={onClickPoojaService}
              className="cursor-pointer"
            />
            <div className="absolute text-white flex flex-col bottom-4 left-4 md:bottom-5 md:left-5 justify-end">
              <h3
                className="text-xl sm:text-2xl lg:text-4xl font-normal tracking-wider leading-tight font-bastoni mb-1 cursor-pointer"
                onClick={onClickPoojaService}
              >
                Home Pooja Services
              </h3>
              <p className="text-md lg:text-xl font-normal">500+ Services</p>
            </div>
          </div>
        </div>
        <div className="w-[100%] h-full md:w-[312px] md:h-[420px] lg:w-352 lg:h-460 rounded-2xl cursor-pointer relative">
          <RightImageBox
            imageUrl={imageBoxesData[1].imageUrl}
            altText={imageBoxesData[1].altText}
            onClick={onClickTempleService}
            className="cursor-pointer"
          />
          <div className="absolute text-white flex flex-col bottom-4 left-4 md:bottom-5 md:left-5 justify-end">
            <h3
              className="text-xl sm:text-2xl lg:text-4xl font-normal tracking-wider leading-tight font-bastoni mb-1 cursor-pointer"
              onClick={onClickTempleService}
            >
              Temple Poojas
            </h3>
            <p className="text-md lg:text-xl font-normal">500+ Services</p>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-center mt-12 mb-20">
        <ImageWrapper
          src="/icons/Group640.svg"
          alt="Line Design"
          width={253}
          height={15}
          className="h-full object-cover"
        />
      </div>
    </div>
  );
};

export default PoojaServices;
